import styled from 'styled-components/native';
import {
    Feather as IconsFE,
    FontAwesome5 as IconsFA5,
  } from "@expo/vector-icons";
import { themes } from '../../../design/colors';

export const Content = styled.ScrollView`
  flex: 1;
  padding: 16px 16px 0 16px;
`;

export const DataUser = styled.Text`
  font-size: 22px;
  color: ${themes.colors.gray3};
  font-weight: bold;
`;


export const TitleDataUser = styled.Text`
  font-size: 12px;
  color: ${themes.colors.gray4};
`;


export const ContentAvatar = styled.View`
  align-items: center;
`;

export const TextDeliveries = styled.Text`
  color: ${themes.colors.black};
  font-weight: bold;
  font-size: 22px;
  margin-top: 6px;
  margin-bottom: 12px;
`;

export const CardLatestDeliveries = styled.View`
    background: ${themes.colors.white};
    border-radius: 10px;
    flex-direction: row;
    justify-content: space-between;
    padding: 15px;
    shadow-color: ${themes.colors.black};
    shadow-opacity: 0.23px;
    shadow-radius: 5px;
    elevation: 1px;
    margin-top: 30px;
`;

export const IconContainer = styled.View`
    background: ${themes.colors.blue0};
    padding: 10px;
    align-self: center;
    border-radius: 10px;
`;

export const IconContainerAction = styled.TouchableOpacity`
    padding: 10px;
    align-self: center;
    border-radius: 10px;
`;

export const IconFE = styled(IconsFE)`
  color: ${themes.colors.primary};
`;

export const IconFA5 = styled(IconsFA5)`
  color: ${themes.colors.primary};
`;

export const ContainerDescription = styled.View`
    padding: 0 20px;
    flex: 1;
    justify-self: flex-start;
    align-self: center;
`;

export const TitleDelivery = styled.Text`
    font-weight: bold;
    font-size: 18px;
`;

export const StatusDelivery = styled.Text`
    color: ${themes.colors.gray1};
`;
